export default __webpack_public_path__ + "static/media/4269.72b04448.png";